module.exports = __webpack_public_path__ + "static/img/14.51f2208.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/fgimg/14.jpg
// module id = q1A6
// module chunks = 18